/*
 * File: CustomTooltip.tsx
 * Project: a-a
 * File Created: Friday, 6th December 2024 11:44:31 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Sunday, 8th June 2025 3:10:51 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

export const LightTooltip = styled(({ className, style, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, style }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: 'rgba(0, 0, 0, 0.12)',
    // box-shadow: ;

    boxShadow: '0px 2px 15px 0px #00000026',
    // fontSize: 11,
    padding: 8,
    ...style,
  },
}));
